/**
 * Creates a query string from a given object of queries.
 * The query string will be in the format of `?key1=value1&key2=value2`.
 * If a query value is `undefined` or `null`, it will be ignored.
 *
 * @param queries - An object containing key-value pairs representing the queries.
 * @returns The generated query string.
 */
const createQueryString = (
    queries: Record<string, string | number | undefined | null>,
): string => {
    const queryValues = queries ? Object.entries(queries) : [];
    let beginWith = "?";
    const queryString = queryValues.reduce((agg, [key, value]) => {
        if (typeof value === "undefined" || value === null) return agg;
        agg += `${beginWith}${encodeURIComponent(
            key,
        )}=${encodeURIComponent(value)}`;
        beginWith = "&";
        return agg;
    }, "");

    return queryString;
};

export { createQueryString };
